import React, { useState, useEffect } from 'react';
import '../MotorradForms.css'; // Используем ваш готовый премиальный файл стилей
import { sendFrontAction } from '../services/api'; // Подключаем единый API-клиент

const Service = () => {
    const [formData, setFormData] = useState({
        client_name: '',
        client_phone: '',
        vin: '',
        service_type: 'Maintenance', 
        description: '',
        scheduled_at: '',
    });

    // Состояние уведомлений (успех/ошибка/загрузка)
    const [message, setMessage] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('Отправка заявки на обслуживание...');

        try {
            // Направляем запрос на экшен 'booking' во FrontController
            const result = await sendFrontAction('booking', formData);
            
            if (result.success) {
                setMessage(`🎉 ${result.message || 'Запись успешно создана!'}`);
                // Полный сброс формы к исходному состоянию
                setFormData({
                    client_name: '',
                    client_phone: '',
                    vin: '',
                    service_type: 'Maintenance',
                    description: '',
                    scheduled_at: '',
                });
            }
        } catch (error) {
            // Ловим ошибки валидации (422) или системные сбои (400 / 500)
            setMessage(`❌ Ошибка: ${error.message || 'Не удалось отправить заявку'}`);
            if (error.errors) {
                console.log('Детали валидации автосервиса:', error.errors);
            }
        }
    };

    return (
        <div className="form-page-wrapper">
            <div className="form-container-box">
                
                {/* Шапка формы полностью по референсу Скрина 2 */}
                <div className="form-header-zone">
                    <h1>ЗАПИСЬ <span className="highlight-text">НА СЕРВИС АВТО</span></h1>
                    <p>Доверьте обслуживание вашего автомобиля официальному сервису BMW Premium Auto</p>
                </div>

                {/* Вывод статус-сообщений */}
                {message && (
                    <div className="form-status-message" style={{ textAlign: 'center', marginBottom: '20px', fontWeight: 'bold' }}>
                        {message}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="premium-form">
                    
                    {/* Ряд 1: Имя и Телефон */}
                    <div className="form-group-row">
                        <div className="input-field">
                            <label>Ваше имя *</label>
                            <input 
                                type="text" name="client_name" required placeholder="Введите имя" 
                                value={formData.client_name} onChange={handleChange} 
                            />
                        </div>
                        <div className="input-field">
                            <label>Номер телефона *</label>
                            <input 
                                type="text" name="client_phone" required placeholder="+998 90 123 45 67" 
                                value={formData.client_phone} onChange={handleChange}
                            />
                        </div>
                    </div>

                    {/* Ряд 2: VIN и Тип услуги */}
                    <div className="form-group-row">
                        <div className="input-field">
                            <label>VIN код автомобиля *</label>
                            <input 
                                type="text" name="vin" required placeholder="Вин код (17 символов)" 
                                maxLength="17" value={formData.vin} onChange={handleChange}
                            />
                        </div>
                        <div className="input-field">
                            <label>Тип услуги</label>
                            <select name="service_type" value={formData.service_type} onChange={handleChange}>
                                <option value="Maintenance">Обслуживание / ТО</option>
                                <option value="Repair">Ремонтные работы</option>
                                <option value="Diagnostics">Компьютерная диагностика</option>
                            </select>
                        </div>
                    </div>

                    {/* Ряд 3: Желаемая дата */}
                    <div className="input-field">
                        <label>Желаемая дата и время визита *</label>
                        <input 
                            type="datetime-local" name="scheduled_at" required 
                            value={formData.scheduled_at} onChange={handleChange} 
                        />
                    </div>

                    {/* Ряд 4: Описание проблемы */}
                    <div className="input-field">
                        <label>Комментарий / Описание проблемы</label>
                        <textarea 
                            name="description" rows="4" placeholder="Опишите проблему коротко"
                            value={formData.description} onChange={handleChange} required>
                        </textarea>
                    </div>

                    {/* Кнопка в премиальном стиле BMW Motorrad (Скриншот 2) */}
                    <button type="submit" className="form-submit-btn">ОТПРАВИТЬ ЗАЯВКУ</button>
                    
                </form>
            </div>
        </div>
    );
};

export default Service;